import { useState, useEffect } from 'react';
import FilterField from './FilterField';
import PropTypes from 'prop-types';

const styles = {
  fields: 'd-flex gap-4 justify-content-between',
  column: 'd-flex flex-column gap-2 flex-grow-1',
  checkbox: 'd-flex gap-2 cursor-pointer',
  dateField: 'd-flex gap-2',
};

const initialDropdownOptions = {
  disabled: [
    { id: 1, data: 'True' },
    { id: 0, data: 'False' },
  ],
  isLoaded: false,
};

const MasterFilters = ({
  visible,
  values,
  defaultValues,
  onChange,
  onSubmit,
  isEPO,
  isEORIUser,
  isTraderUser,
  dates,
}) => {
  // --------------------
  // 1. Declaring state
  // --------------------
  const [dropdownOptions, setDropdownOptions] = useState(initialDropdownOptions);

  // -------------------------------
  // 3. Change functions for form
  // -------------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange((prev) => {
      const base = prev && typeof prev === 'object' ? prev : {};
      const next = { ...base, [name]: value };
      return next;
    });
  };

  const hasAnyFilterSelected = (values, options = {}) => {
    if (!values || typeof values !== 'object') return false;
    const { excludeWhen } = options;
    return Object.entries(values).some(([key, value]) => {
      if (excludeWhen && excludeWhen(key, value)) return false;
      if (value == null) return false;
      if (typeof value === 'string' && value.trim() === '') return false;
      return true;
    });
  };

  if (!visible) return null;

  // --------------------
  // 4. Main component
  // --------------------
  return (
    <div className="px-3 mt-4">
      <div className={styles.fields}>
        <div className={styles.column}>
          <FilterField
            label="Document Code"
            field="documentCode"
            value={values.documentCode}
            onChange={handleChange}
            allowsWildcard
            dataTestId="type-textField"
          />
          <FilterField
            label="Description"
            field="description"
            value={values.description}
            onChange={handleChange}
            dataTestId="description-textField"
          />
        </div>
        <div className={styles.column}>
          <FilterField
            label="Disabled"
            field="disabled"
            value={values.disabled}
            options={dropdownOptions.disabled}
            onChange={handleChange}
            dataTestId="type-combobox"
          />
        </div>
      </div>

      <div className="text-end">
        <button
          className="stepper-button yellow"
          data-testid="applyFilters-button"
          onClick={onSubmit}
          disabled={
            !hasAnyFilterSelected(values || {}, {
              excludeWhen: (k, v) => k === 'excludeCompleted' && (v === 1 || v === undefined),
            })
          }
        >
          Apply Filters
        </button>
      </div>
    </div>
  );
};

MasterFilters.propTypes = {
  visible: PropTypes.bool,
  values: PropTypes.shape({
    documentCode: PropTypes.string,
    description: PropTypes.string,
    disabled: PropTypes.bool,
    exclCompleted: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  }),
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default MasterFilters;
